import React, { useState } from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Box, Typography, Button } from "@mui/material";

function TableServices() {
    const isMobile = useMediaQuery("(max-width:600px)");
    const [showOverlay, setShowOverlay] = useState(true);

    const rows = [
        { time: "2h", price: "799,-", limit: "50km" },
        { time: "8h", price: "1299,-", limit: "200km" },
        { time: "12h", price: "1599,-", limit: "500km" },
    ];

    const handleTouch = () => {
        setShowOverlay(false);
    };


    return (
        <Box position="relative">
            {showOverlay && isMobile && (
                <Box
                    component={Button}
                    position="absolute"
                    top={0}
                    left={0}
                    right={0}
                    bottom={0}
                    bgcolor="rgba(0, 0, 0, 0.5)"
                    color="white"
                    display="flex"
                    alignItems="center"
                    zIndex={999}
                    justifyContent="center"
                    onTouchStart={handleTouch}
                    onClick={handleTouch}
                    
                >
                    <Typography variant="body1">Posuňte doprava</Typography>
                </Box>
            )}
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{fontWeight : 600}}>Doba zapůjčení</TableCell>
                            <TableCell sx={{fontWeight : 600}}>Cena v Kč</TableCell>
                            <TableCell sx={{fontWeight : 600}}>Nájezd do</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((row, index) => (
                            <TableRow key={index}>
                                <TableCell>{row.time}</TableCell>
                                <TableCell>{row.price}</TableCell>
                                {row.limit === "neomezené" ? (
                                    <TableCell sx={{color : "success.main"}}>{row.limit}</TableCell>
                                ) : (
                                    <TableCell>{row.limit}</TableCell>
                                )}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
}

export default TableServices;